// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"Modal_modalContainer__1VWPG","content":"Modal_content__2gFAo","close":"Modal_close__36IEx","darkBG":"Modal_darkBG__1n08X"};